import { Route, Routes } from "react-router-dom";

import MainPage from "./MainPage";
import DetailsPage from "./DetailsPage";

export default function Services() {
  return (
    <div className="flex flex-col justify-center items-center">
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/coming-soon" element={<DetailsPage />} />
      </Routes>
    </div>
  )
}
